import * as DomBuilder from "./dom-builder.js";

/**
 *
 * @version 2026-09-02
 * @author Patrik Harag
 */
export default class ComponentOptionsFxView {

    /** @type {function()} */
    #refreshFunction;
    /** @type {boolean} */
    #checked = false;
    /** @type {HTMLElement} */
    #node;

    /**
     *
     * @param refreshFunction {function()}
     */
    constructor(refreshFunction) {
        this.#refreshFunction = refreshFunction;
    }

    createNode() {
        let labelContent = DomBuilder.element('i', { class: 'fa fa-columns' });
        let toggleButton = DomBuilder.bootstrapToggleButton(labelContent, 'btn-secondary', this.#checked, b => {
            this.#checked = b;
            this.#refreshFunction();
        });

        this.#node = DomBuilder.div({ class: 'fx-view-component' }, toggleButton);
        return this.#node;
    }

    setDisabled(disabled) {
        if (!this.#node) {
            return;
        }
        if (disabled) {
            this.#node.style.display = 'none';
        } else {
            this.#node.style.display = '';
        }
    }

    isSelected() {
        return this.#checked;
    }
}
